package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FavoriteW500Rounded: ImageVector
    get() {
        if (_favoriteW500Rounded != null) {
            return _favoriteW500Rounded!!
        }
        _favoriteW500Rounded = Builder(name = "FavoriteW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(447.32f, 814.34f)
                quadToRelative(-16.3f, -5.84f, -28.97f, -18.27f)
                lineToRelative(-69.48f, -63.48f)
                quadTo(243.35f, 636.3f, 157.61f, 539.97f)
                quadTo(71.87f, 443.63f, 71.87f, 326.0f)
                quadToRelative(0.0f, -97.58f, 65.15f, -162.97f)
                quadToRelative(65.15f, -65.4f, 162.74f, -65.4f)
                quadToRelative(52.52f, 0.0f, 99.28f, 21.42f)
                quadToRelative(46.76f, 21.43f, 80.72f, 59.47f)
                quadToRelative(33.96f, -38.04f, 80.72f, -59.47f)
                quadToRelative(46.76f, -21.42f, 99.28f, -21.42f)
                quadToRelative(97.68f, 0.0f, 163.14f, 65.4f)
                quadToRelative(65.47f, 65.39f, 65.47f, 162.97f)
                quadToRelative(0.0f, 117.63f, -85.6f, 214.47f)
                quadToRelative(-85.6f, 96.83f, -193.12f, 193.36f)
                lineToRelative(-68.24f, 62.47f)
                quadToRelative(-12.67f, 12.44f, -29.08f, 18.16f)
                quadToRelative(-16.42f, 5.71f, -32.57f, 5.71f)
                reflectiveQuadToRelative(-32.44f, -5.83f)
                close()
                moveTo(440.09f, 271.2f)
                quadToRelative(-27.57f, -39.57f, -60.93f, -61.07f)
                reflectiveQuadToRelative(-79.33f, -21.5f)
                quadToRelative(-58.7f, 0.0f, -97.83f, 39.16f)
                quadToRelative(-39.13f, 39.17f, -39.13f, 98.21f)
                quadToRelative(0.0f, 51.54f, 36.64f, 109.52f)
                quadToRelative(36.64f, 57.99f, 87.64f, 112.5f)
                quadToRelative(51.0f, 54.52f, 104.97f, 102.09f)
                quadToRelative(53.97f, 47.58f, 87.64f, 78.3f)
                quadToRelative(33.76f, -31.0f, 87.83f, -78.55f)
                quadToRelative(54.07f, -47.56f, 105.16f, -102.04f)
                quadToRelative(51.1f, -54.49f, 87.86f, -112.28f)
                quadToRelative(36.76f, -57.78f, 36.76f, -109.54f)
                quadToRelative(0.0f, -59.04f, -39.28f, -98.21f)
                quadToRelative(-39.29f, -39.16f, -98.21f, -39.16f)
                quadToRelative(-46.16f, 0.0f, -79.4f, 21.5f)
                quadToRelative(-33.24f, 21.5f, -60.81f, 61.07f)
                quadToRelative(-7.31f, 10.71f, -17.75f, 16.07f)
                quadToRelative(-10.44f, 5.36f, -22.16f, 5.36f)
                reflectiveQuadToRelative(-22.07f, -5.36f)
                quadToRelative(-10.36f, -5.36f, -17.6f, -16.07f)
                close()
                moveTo(480.0f, 458.52f)
                close()
            }
        }
        .build()
        return _favoriteW500Rounded!!
    }

private var _favoriteW500Rounded: ImageVector? = null
